import { FC } from "react";
import FormFieldComponent from "../../../../../../../../common/components/form/field/form-field.component";
import InputComponent from "../../../../../../../../common/components/form/input/input.component";
import Column from "../../../../../../../../common/components/grid/column";
import Row from "../../../../../../../../common/components/grid/row";
import FormValidationResult from "../../../../../../../../common/utils/validation/types/form-validation-result";
import userTranslationsHelper from "../../../../../../../../languages/user-translations.helper";
import DriverAddCompanyFormData from "../../../form/types/driver-add-company-form-data";

type DriverAddCompanyDataProps = {
  validateCompanyData: (
    formKey: keyof DriverAddCompanyFormData,
    value?: unknown
  ) => Promise<boolean>;
  onCompanyDataChange: (
    formKey: keyof DriverAddCompanyFormData,
    value: any
  ) => void;
  companyValidationResults: Record<
    keyof DriverAddCompanyFormData,
    FormValidationResult
  >;
  companyFormValues: DriverAddCompanyFormData;
};

const DriverAddCompanyDataComponent: FC<DriverAddCompanyDataProps> = (
  props
) => {
  const translations =
    userTranslationsHelper.getDriverAddTranslations().form.companyData;

  return (
    <>
      <Row>
        <Column>
          <FormFieldComponent
            label={translations.nameLabel}
            isRequired
            classNames={{ root: "mt-0" }}
            errorMessage={props.companyValidationResults.name.errorMessage}
          >
            <InputComponent
              placeholder={translations.namePlaceholder}
              value={props.companyFormValues.name}
              onChange={(value) => props.onCompanyDataChange("name", value)}
              onBlur={() => {
                props.validateCompanyData("name");
              }}
              hasError={!!props.companyValidationResults.name.errorMessage}
              idForTesting="company-data-company-name-input"
            />
          </FormFieldComponent>
        </Column>
      </Row>
      <Row>
        <Column xl={6}>
          <FormFieldComponent
            label={translations.taxNumberLabel}
            isRequired
            errorMessage={props.companyValidationResults.taxNumber.errorMessage}
            classNames={{ root: "mt-0" }}
          >
            <InputComponent
              placeholder={translations.taxNumberPlaceholder}
              value={props.companyFormValues.taxNumber}
              onChange={(value) =>
                props.onCompanyDataChange("taxNumber", value)
              }
              onBlur={() => {
                props.validateCompanyData("taxNumber");
              }}
              hasError={!!props.companyValidationResults.taxNumber.errorMessage}
              idForTesting="company-data-tax-number-input"
            />
          </FormFieldComponent>
        </Column>
        <Column xl={6}>
          <FormFieldComponent
            label={translations.companyIdLabel}
            errorMessage={props.companyValidationResults.companyId.errorMessage}
            classNames={{ root: "mt-0" }}
          >
            <InputComponent
              placeholder={translations.companyIdPlaceholder}
              value={props.companyFormValues.companyId}
              onChange={(value) =>
                props.onCompanyDataChange("companyId", value)
              }
              onBlur={() => {
                props.validateCompanyData("companyId");
              }}
              hasError={!!props.companyValidationResults.companyId.errorMessage}
              idForTesting="company-data-company-id-input"
            />
          </FormFieldComponent>
        </Column>
        <Column xl={6}>
          <FormFieldComponent
            label={translations.nationalCourtRegisterLabel}
            errorMessage={
              props.companyValidationResults.nationalCourtRegisterNumber
                .errorMessage
            }
            classNames={{ root: "mt-0" }}
          >
            <InputComponent
              placeholder={translations.nationalCourtRegisterPlaceholder}
              value={props.companyFormValues.nationalCourtRegisterNumber}
              onChange={(value) =>
                props.onCompanyDataChange("nationalCourtRegisterNumber", value)
              }
              onBlur={() => {
                props.validateCompanyData("nationalCourtRegisterNumber");
              }}
              hasError={
                !!props.companyValidationResults.nationalCourtRegisterNumber
                  .errorMessage
              }
              idForTesting="company-data-national-court-register-input"
            />
          </FormFieldComponent>
        </Column>
      </Row>
    </>
  );
};

export default DriverAddCompanyDataComponent;
